import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '数据实体',
    type: 'BDRULE_1',
}
